import { ManuteRequestConfig } from '@/api/types';
import { CalendarSubscriptionRequest, CalendarSubscriptionRequestBody } from '@/api/requests/calendar/types';

/**
 * Request to find all calendars which user is subscribed to.
 */
export const ALL_SUBSCRIBED_CALENDARS = (): ManuteRequestConfig => ({
    method: 'GET',
    url: '/users/me/calendars',
});

/**
 * Request to find a calendar by id.
 * @param calendarId
 */
export const FIND_SUBSCRIBED_CALENDAR = (calendarId: string | number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/users/me/calendars/${calendarId}`,
});

/**
 * Request to add a calendar to user subscriptions.
 * @param data
 */
export const SUBSCRIBE_CALENDAR = (data: CalendarSubscriptionRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/users/me/calendars`,
    data,
});

/**
 * Request to update a calendar subscription settings.
 * @param calendarId
 * @param data
 */
export const UPDATE_SUBSCRIBED_CALENDAR = (
    calendarId: string | number,
    data: CalendarSubscriptionRequestBody): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/users/me/calendars/${calendarId}`,
    data,
});

/**
 * Request to delete a calendar from user subscriptions.
 * @param calendarId
 */
export const UNSUBSCRIBE_CALENDAR = (calendarId: string | number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/users/me/calendars/${calendarId}`,
});
